var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "vh-100", attrs: { "align-v": "center" } },
    [
      _c(
        "b-col",
        { attrs: { cols: "6" } },
        [
          _c(
            "b-row",
            { staticClass: "custom-container" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("img", {
                  staticClass: "mb-4",
                  staticStyle: { width: "20%" },
                  attrs: { src: require("img/logos/RGB_OPENSALUD_AZUL.svg") }
                }),
                _c("br")
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("h4", [_vm._v("Opensalud Vue WebApp")])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "6", id: "woman-bg" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8648c4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8648c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/OpensaludLanding.vue
// module id = 4217
// module chunks = 110